module.exports = __webpack_public_path__ + "img/Compsoft_logo.79dfcc52.png";